"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _lottieWeb = _interopRequireDefault(require("lottie-web"));
var _react = _interopRequireWildcard(require("react"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var RenderAnimation = function RenderAnimation(_ref) {
  var _ref$animationJSON = _ref.animationJSON,
    animationJSON = _ref$animationJSON === void 0 ? null : _ref$animationJSON,
    _ref$animationName = _ref.animationName,
    animationName = _ref$animationName === void 0 ? '' : _ref$animationName,
    _ref$animationDivId = _ref.animationDivId,
    animationDivId = _ref$animationDivId === void 0 ? '' : _ref$animationDivId,
    _ref$preserveAspectRa = _ref.preserveAspectRatio,
    preserveAspectRatio = _ref$preserveAspectRa === void 0 ? 'none' : _ref$preserveAspectRa,
    _ref$loop = _ref.loop,
    loop = _ref$loop === void 0 ? true : _ref$loop;
  (0, _react.useEffect)(function () {
    _lottieWeb["default"].loadAnimation({
      container: document.getElementById(animationDivId),
      animationData: animationJSON,
      loop: loop,
      renderer: 'svg',
      name: animationName,
      rendererSettings: {
        preserveAspectRatio: preserveAspectRatio
      }
    });
  }, []);
  return /*#__PURE__*/_react["default"].createElement("div", {
    "data-sentry-component": "RenderAnimation",
    "data-sentry-source-file": "RenderAnimation.tsx"
  });
};
var _default = RenderAnimation;
exports["default"] = _default;